import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[appSecureVideo]'
})
export class SecureVideoDirective implements OnInit {
  srcUrl!: string;

  constructor(
    private el: ElementRef,
    private http: HttpClient,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.srcUrl = this.el.nativeElement.src;
    this.renderer.setAttribute(this.el.nativeElement, 'src', '');

    this.http.get(this.srcUrl, { responseType: 'blob' }).subscribe((response) => {
      const blob = new Blob([response], { type: 'video/mp4' });
      // Sanitize the URL and update video src
      this.el.nativeElement.src = URL.createObjectURL(blob);
    });
  }
}
